import adminAutoSlice from './adminAuto.slice';
import adminBlackListSlice from './adminBlackList.slice';
import adminClientsSlice from './adminClients.slice';
import adminModulesSlice from './adminModules.slice';
import adminProductsSlice from './adminProducts.slice';
import adminReportsSlice from './adminReports.slice';
import adminUsersSlice from './adminUsers.slice';

export const adminStore = {
  adminUsers: adminUsersSlice.reducer,
  adminClients: adminClientsSlice.reducer,
  adminModules: adminModulesSlice.reducer,
  adminProducts: adminProductsSlice.reducer,
  adminAuto: adminAutoSlice.reducer,
  adminReports: adminReportsSlice.reducer,
  adminBlackList: adminBlackListSlice.reducer
};
